import { Controller } from "../../Controller"
import { ListarTipoParcelaService, CadastrarTipoParcelaService, DeletarTipoParcelaService, AtualizarTipoParcelaService } from '../../../Services/Cobranca/TipoParcela/TipoParcelaService';
import { ITipoParcela } from "../../../Interfaces/Cobranca/TipoParcela/TipoParcelaInterface";

export const ListarTipoParcelaController = (pag: number) => Controller(
    ListarTipoParcelaService(pag)
)

export const CadastrarTipoParcelaController = (Parcela: ITipoParcela) => Controller(
    CadastrarTipoParcelaService(Parcela)
)

export const DeletarTipoParcelaController = (ID_TIPO_PARCELA: number) => Controller(
    DeletarTipoParcelaService(ID_TIPO_PARCELA)
)

export const AtualizarTipoParcelaController = (Parcela: ITipoParcela) => Controller(
    AtualizarTipoParcelaService(Parcela)
)
